import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Divider from "@amzn/meridian/divider";
import { FEATURES } from "../constants/messages";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const FeaturesComparison = ({ widths, isCanada, isSortCenter }) => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);

  return (
    <Column spacing="300">
      <Row></Row>
      {FEATURES.map((feature, featureIndex) => {
        const {
          title,
          values: [
            plugfones,
            elgin,
            plugfones_sovereign,
            plugfones_mercenary_lt,
            plugfones_allert,
          ],
        } = feature;

        const getFeatureValues = () => {
          if (isSortCenter) {
            return [plugfones_allert];
          }
          if (isCanada) {
            return [plugfones, plugfones_sovereign, plugfones_mercenary_lt];
          }
          return [plugfones, elgin, plugfones_mercenary_lt];
        };

        return (
          <Column key={featureIndex}>
            <Row widths={widths}>
              <Text fontFamily={"bookerlyDisplay"} type="h100">
                <Column width={"70%"}>{t(bundle, title)}</Column>
              </Text>
              {getFeatureValues().map((value, valueIndex) => (
                <Text fontFamily={"bookerly"} key={valueIndex}>
                  <Column key={valueIndex} width={"70%"}>
                    {featureIndex < FEATURES.length - 1 ? (
                      <Text>{t(bundle, value)}</Text>
                    ) : (
                      <Text>{value}</Text>
                    )}
                  </Column>
                </Text>
              ))}
            </Row>
            {featureIndex < FEATURES.length - 1 && (
              <Row>
                <Divider />
              </Row>
            )}
          </Column>
        );
      })}
    </Column>
  );
};

export default FeaturesComparison;
